import openApiHttp from "@/utils/request2"
export let classifytag = () => {
    return openApiHttp({
        url: "/book/listBookCategory",
    }, false)
}
export let searchget = (params) => {
    return openApiHttp({
        url: "/book/searchByPage",
        params,
    }, false)
}